import { Route, Routes } from "react-router-dom";

import AllEmployees from "./all/AllEmployees";
import { DetailEmployee } from "./details/DetailEmployee";

function Employees() {
  return (
    <Routes>
      <Route path="/" element={<AllEmployees />} />
      <Route path="/:id/*" element={<DetailEmployee />} />
    </Routes>
  )
}

export default Employees;
